import React from 'react';
import { Container } from 'react-bootstrap';

const OutsourcingCost3 = props => {
    return (
        <section id="outsourcing-cost-section3" className="my pt-5 ">
            <div className='white-shape'></div>
            <Container>
                <div className="title-triangle top-md fw-600"></div>
                <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingCost:section-3.title')}</h2>
                <p className='mb-4'>{props.t('services:outsourcingCost:section-3.txt')}</p>
                <ul className='m-0'>
                    {props.t('services:outsourcingCost:section-3.list', { returnObjects: true }).map((item, index) => (
                        <li key={index}><p className='m-0'>{item}</p></li>
                    ))}
                </ul>
            </Container>
        </section>
    );
};

export default OutsourcingCost3;
